import { devLog } from "./commons/LogUtils";

export function fillPageMetaDetails(referralData: any): void {
    window.prefs = window.prefs || {};

    window.prefs.pageTitle = (referralData && referralData.pageTitle) || "EngageBay-CRM";
    window.prefs.pageDescription = (referralData && referralData.pageDescription) || "EngageBay Dashboard";
    window.prefs.favIcon = (referralData && referralData.favIcon) || "https://d2p078bqz5urf7.cloudfront.net/cloud/assets/img/logo/fav/ab-16x16.ico";

    devLog("Updated prefs:", window.prefs);
}